<template lang="pug">
    .msg
        .left(v-loading="loading")
            .cards(v-if="orders && orders.length")
                el-card.card(v-for="item in orders" :key="item.id" @click.native="changeDetail(item)")
                    p 订单ID: {{item.id}}
                    p 订单类型：{{item.goods_type_cn}}
                    p 订单价格：&yen;{{(item.amount_total / 100).toFixed(2)}}
                    p 订单状态：{{item.status_cn}}
            el-pagination.order-page(v-if="orders && orders.length" background layout="prev, pager, next" :page-size="size" :total="count" :current-page="page"  @current-change="pageChange" small)

            .nomsg(v-else)
                el-empty(:image-size="100")
        .right.box(v-loading="aoiLoading")
            .detail(v-if="detail")
                p
                    strong 订单ID：
                    | {{detail.id}}
                p
                    strong 创建时间：
                    | {{new Date(detail.created_at * 1000).toLocaleString()}}

                p
                    strong 订单类型：
                    | {{detail.goods_type_cn}}
                p
                    strong 订单价格：
                    | &yen;{{(detail.amount_total / 100).toFixed(2)}}
                p
                    strong 订单状态：
                    | {{detail.status_cn}}
                .pay(v-if="detail.status == 'wait_pay' && detail.pay_url")
                    Wepay(:orderId="detail.id" :payUrl="detail.pay_url" @success="paySuccess")
                    p 使用微信扫码支付
                .map-container(:style="{paddingBottom: '500px'}")
                    POLYGON_MAP(:aoi="aoi")
            .nomsg(v-else)
                el-empty(:image-size="100")


</template>

<script>
import POLYGON_MAP from '../components/map/polygon.vue';
import storeMixin from '../store/mixin';
import Wepay from '../components/wepay.vue';

export default {
    name: 'Order',
    components: { POLYGON_MAP, Wepay },
    mixins: [storeMixin],
    data() {
        return {
            loading: false,
            orders: null,
            size: 5,
            count: 0,
            page: 1,
            detail: null,
            aoi: null,
            aoiLoading: false,
        };
    },
    created() {
        console.log('created');
        this.getOrders();
    },
    methods: {
        async getOrders() {
            if (this.loading) return;
            this.loading = true;
            try {
                const result = await this.REQUEST({
                    url: `v2/order/list?limit=${this.size}&page=${this.page}`,
                });
                console.log(result);
                this.orders = result.data.items || [];
                this.count = result.data.count;
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },
        async getAoi(id) {
            if (this.aoiLoading) return;
            this.aoiLoading = true;
            try {
                const result = await this.REQUEST({
                    url: `v2/aoi/list?id=${id}`,
                });
                this.aoi = result.data.items[0];
            } catch (e) {
                console.log(e);
            }
            this.aoiLoading = false;
        },
        pageChange(n) {
            this.page = n;
            this.getOrders();
        },
        changeDetail(item) {
            this.detail = item;
            this.getAoi(item.goods_value);
        },
        paySuccess() {
            this.detail.status = 'done';
            this.$message({
                message: '支付成功',
                type: 'success',
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
*
    padding 0
.msg
    display flex
    width 100%
.left
    margin 0 20px 0 0
    width 300px
    flex-shrink 0
.nomsg
    width 100%
    height 100%
    display flex
    flex-direction column
    align-items center
    justify-content center
    & > *
        margin 10px 0
.cards
    min-height calc(100% - 50px)
.card
    margin-bottom 10px
    cursor pointer
    background #1e1f25
.order-page
    margin 20px 0
    text-align center
.right
    flex-grow 1
    padding 50px 50px 20px 50px
    line-height 2rem
    strong
        font-size 1.2rem
    .map-container
        padding 20px 0
        position relative
</style>
